import React, { useEffect, useRef } from 'react';
import styled from 'styled-components';
import { Select } from 'antd';
import { Field, ErrorMessage, FieldAttributes, FieldProps } from 'formik';
import { EllipsisOutlined } from '@ant-design/icons';

const Wrapper = styled.tr`
  color: ${(props) => props.theme.colors.primary};
  font-size: 1rem;

  @media only screen and (max-width: 768px) {
    .labelContainer {
      display: block;
      min-width: 160px;
    }
  }

  td {
    padding: 5px 10px;
    vertical-align: top;

    &:first-child {
      font-weight: 500;
      padding-top: 8px;
    }

    .ant-select {
      border: 1px solid ${(props) => props.theme.colors.primary};
      width: 100%;
      font-size: 1rem;

      .ant-select-selector {
        border: 0;
        font-size: 1rem;
      }

      input {
        font-size: 1rem;
      }
    }

    .error {
      font-size: 0.8rem;
      color: ${(props) => props.theme.colors.red};
      margin-bottom: -5px;
    }

    button {
      // position: absolute;
      // top: 0;
      margin-right: -10%;
      background-color: ${(props) => props.theme.colors.primary};
      width: 30px;
      cursor: pointer;
      z-index: 2;

      svg {
        fill: white;
      }
    }
  }
`;

const SelectField: React.FC<FieldAttributes<any>> = ({
  label,
  options,
  disabled,
  isAutoFocus = false,
  moreButton = null,
  secondRowOrColumn = 'Row',
  secondWidth = '100%',
  ...props
}) => {
  const selectRef = useRef<any>(null);

  useEffect(() => {
    if (isAutoFocus) {
      selectRef?.current?.focus();
    }
  }, [isAutoFocus]);

  const secondTdStyle = {
    display: 'flex',
    flexDirection: secondRowOrColumn,
    maxWidth: secondWidth,
    width: secondWidth,
  };
  if (moreButton !== null) {
    secondTdStyle.maxWidth = '92%';
    secondTdStyle.width = '92%';
  }

  return (
    <Wrapper>
      <td className="labelContainer" style={{ minWidth: 160 }}>
        {label}
      </td>
      <td style={secondTdStyle}>
        <Field {...props}>
          {({
            field: { name, value, onBlur },
            form: { setFieldValue },
          }: FieldProps) => {
            return (
              <Select
                value={value}
                onBlur={onBlur}
                disabled={disabled}
                onChange={(v) => {
                  if (props.onChange) {
                    props.onChange(v, setFieldValue);
                  }
                  setFieldValue(name, v);
                }}
                showSearch
                placeholder={props.placeholder}
                optionFilterProp="children"
                filterOption={(input, option) => {
                  // Auto select for State to be based upon 2 digit state code instead of full name
                  if (label === 'State') {
                    const isFiltered =
                      String(option?.label)
                        .toLowerCase()
                        .indexOf(input.toLowerCase()) >= 0 ||
                      String(option?.value)
                        .toLowerCase()
                        .indexOf(input.toLowerCase()) >= 0;
                    return isFiltered;
                  }
                  return (
                    String(option?.label)
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                  );
                }}
                getPopupContainer={(target) =>
                  target?.parentNode || document.body
                }
                options={options}
                ref={selectRef}
              />
            );
          }}
        </Field>
        {moreButton && (
          <button type="button" onClick={() => moreButton()}>
            <EllipsisOutlined />
          </button>
        )}
        <ErrorMessage name={props.name} component="div" className="error" />
      </td>
    </Wrapper>
  );
};

export default SelectField;
